import { gql } from '@apollo/client';

const CLINIC_NOTIFICATIONS_QUERY = gql`
  query clinicNotifications($filter: ClinicNotificationFilterInput, $limit: Int) {
    clinicNotifications(filter: $filter, limit: $limit) {
      id
      type
      isSeen
      createdAt
      notification {
        studiesCount
        artifactStudiesCount
        rmaTicket {
          rmaId
        }
        facility {
          id
          name
          programs {
            protectPlus
            renewalStock
          }
          canViewFlaggedStudies
        }
        info
      }
    }
  }
`;

export default CLINIC_NOTIFICATIONS_QUERY;
